"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Credits = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _styles = require("./styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CreditsText = ({
  category,
  title,
  name,
  link
}) => _react.default.createElement(_react.default.Fragment, null, !!category && _react.default.createElement(_styles.Category, null, category), _react.default.createElement(_styles.Content, null, _react.default.createElement(_styles.Title, null, title, ":", ' ', !link && _react.default.createElement(_styles.Name, null, name) || _react.default.createElement(_styles.Link, {
  href: link,
  target: "_blank",
  rel: "noreferrer"
}, _react.default.createElement(_styles.Name, null, name)))));
const Credits = ({
  creditsTexts,
  enableAnimation,
  setAnimationDuration = 0.75
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  const containerDropdownRef = (0, _react.useRef)(null);
  const containerContentRef = (0, _react.useRef)(null);
  const isAnimationEnable = enableAnimation === 'true' || enableAnimation === true;
  const showCredits = () => {
    _bricksUtils.gsap.timeline().to(containerDropdownRef.current, {
      opacity: 0,
      display: 'none',
      duration: 0
    }, '<').to(containerContentRef.current, {
      maxHeight: `${containerContentRef.current.scrollHeight}px`,
      duration: 0.5
    }, '<');
  };
  (0, _react.useEffect)(() => {
    if (!containerContentRef.current || !isAnimationEnable) return;
    let fadeAnimation = _bricksUtils.gsap.effects.fade(containerDropdownRef.current, {
      duration: setAnimationDuration,
      trigger: wrapperRef.current
    });
    return () => {
      if (fadeAnimation) fadeAnimation.kill();
    };
  }, [enableAnimation, setAnimationDuration]);
  return _react.default.createElement(_styles.Wrapper, {
    className: "credits-container",
    ref: wrapperRef
  }, _react.default.createElement(_styles.DropdownCreditsContainer, {
    onClick: showCredits,
    ref: containerDropdownRef
  }, _react.default.createElement(_styles.CreditsHeading, null, "Credits"), _react.default.createElement(_styles.Chevron, {
    viewBox: "0 0 32 32"
  }, _react.default.createElement("path", {
    strokeWidth: "2",
    d: "M15 6.667L28.333 20 15 33.333",
    vectorEffect: "non-scaling-stroke"
  }))), _react.default.createElement(_styles.ContentCredits, null, _react.default.createElement(_styles.Container, {
    ref: containerContentRef
  }, _react.default.createElement(_bricksTheme.default, null), creditsTexts.map(creditsText => _react.default.createElement(CreditsText, {
    key: creditsText.id,
    category: creditsText.category,
    name: creditsText.name,
    title: creditsText.title,
    link: creditsText.link
  })))));
};
exports.Credits = Credits;
//# sourceMappingURL=index.js.map